var $fbfac0c9f82929a4$exports = {};
$fbfac0c9f82929a4$exports = {
    "longPressMessage": `Premi a lungo o premi Alt + Freccia gi\xf9 per aprire il menu`
};


export {$fbfac0c9f82929a4$exports as default};
//# sourceMappingURL=it-IT.mjs.map
